import {BreakpointObserver} from '@angular/cdk/layout'
import {inject, Injectable, signal, WritableSignal} from '@angular/core'
import {InfoMessageKeys} from '../types'



@Injectable({
  providedIn: 'root'
})
export class OrientationService {
  /**
   * shows a link in full screen when we have a value
   */
  public pdfUrl$: WritableSignal<string> = signal('')


  /**
   * Property to show info message
   */
  public showInfoMessage$: WritableSignal<InfoMessageKeys> = signal('')

  /**
   * Property to track if the screen is large
   */
  public isSmallScreen$: WritableSignal<boolean> = signal(false)

  /**
   * Check screen size changes and since mat-stepper has a max-width of 1130px,
   * isSmallScreen < 1150px.
   */
  constructor() {
    const breakpointObserver = inject(BreakpointObserver)

    breakpointObserver.observe('(max-width: 1149px)')
      .subscribe(r => this.isSmallScreen$.set(r.matches))
  }
}
